// Canlı operasyon, GPS sağlığı, destek, kimliğe bürünme, güvenlik, KVKK, sürümler, şablonlar, denetim, sistem
// (A07, A08, A10–A16, A18, A19). Index rotası business alanındadır.
import { Route } from 'react-router';
import { guard, load } from '../../route-utils';

const LiveOps = load(() => import('./LiveOps'), 'LiveOps');
const GpsHealth = load(() => import('./GpsHealth'), 'GpsHealth');
const SupportList = load(() => import('./SupportList'), 'SupportList');
const SupportTicket = load(() => import('./SupportTicket'), 'SupportTicket');
const Impersonation = load(() => import('./Impersonation'), 'Impersonation');
const Security = load(() => import('./Security'), 'Security');
const Privacy = load(() => import('./Privacy'), 'Privacy');
const AppVersions = load(() => import('./AppVersions'), 'AppVersions');
const NotificationTemplates = load(() => import('./NotificationTemplates'), 'NotificationTemplates');
const AuditLogs = load(() => import('./AuditLogs'), 'AuditLogs');
const SystemHealth = load(() => import('./SystemHealth'), 'SystemHealth');

export const adminPlatformRoutes = (
  <>
    <Route path="platform/canli" element={guard(LiveOps, 'platform')} />
    <Route path="platform/gps-sagligi" element={guard(GpsHealth, 'platform')} />
    <Route path="destek" element={guard(SupportList, 'support')} />
    <Route path="destek/:id" element={guard(SupportTicket, 'support')} />
    <Route path="firma-olarak-giris" element={guard(Impersonation, 'security')} />
    <Route path="guvenlik" element={guard(Security, 'security')} />
    <Route path="gizlilik" element={guard(Privacy, 'privacy')} />
    <Route path="uygulama-surumleri" element={guard(AppVersions, 'platform')} />
    <Route path="bildirim-sablonlari" element={guard(NotificationTemplates, 'platform')} />
    <Route path="denetim-kaydi" element={guard(AuditLogs, 'audit')} />
    <Route path="sistem" element={guard(SystemHealth, 'platform')} />
  </>
);
